/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Membership } from './Membership';
import {
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
    MembershipToJSONTyped,
} from './Membership';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
    TeamToJSONTyped,
} from './Team';

/**
 *
 * @export
 * @interface MembershipDetails
 */
export interface MembershipDetails {
    /**
     *
     * @type {Team}
     * @memberof MembershipDetails
     */
    readonly team: Team;
    /**
     *
     * @type {Membership}
     * @memberof MembershipDetails
     */
    readonly membership: Membership;
    /**
     *
     * @type {boolean}
     * @memberof MembershipDetails
     */
    readonly isSelf: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MembershipDetails
     */
    readonly canEdit: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MembershipDetails
     */
    readonly canRemove: boolean;
    /**
     *
     * @type {string}
     * @memberof MembershipDetails
     */
    readonly removalBlockedReason: string | null;
}

/**
 * Check if a given object implements the MembershipDetails interface.
 */
export function instanceOfMembershipDetails(value: object): value is MembershipDetails {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('membership' in value) || value['membership'] === undefined) return false;
    if (!('isSelf' in value) || value['isSelf'] === undefined) return false;
    if (!('canEdit' in value) || value['canEdit'] === undefined) return false;
    if (!('canRemove' in value) || value['canRemove'] === undefined) return false;
    if (!('removalBlockedReason' in value) || value['removalBlockedReason'] === undefined) return false;
    return true;
}

export function MembershipDetailsFromJSON(json: any): MembershipDetails {
    return MembershipDetailsFromJSONTyped(json, false);
}

export function MembershipDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipDetails {
    if (json == null) {
        return json;
    }
    return {

        'team': TeamFromJSON(json['team']),
        'membership': MembershipFromJSON(json['membership']),
        'isSelf': json['is_self'],
        'canEdit': json['can_edit'],
        'canRemove': json['can_remove'],
        'removalBlockedReason': json['removal_blocked_reason'],
    };
}

  export function MembershipDetailsToJSON(json: any): MembershipDetails {
      return MembershipDetailsToJSONTyped(json, false);
  }

  export function MembershipDetailsToJSONTyped(value?: Omit<MembershipDetails, 'team'|'membership'|'is_self'|'can_edit'|'can_remove'|'removal_blocked_reason'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
